export enum NO_RESULT_CASE {
  'Error',
  'SearchQuery',
  'FiltersApplied',
}
